import { Services, isValidEmail, isValidPassword } from '@sigma-frontend-libs/commons'

import { isEmpty, isValidPhone, isValidUserName, proxy, validation } from '@/utils'

import render from './render'

export default {
  name: 'RegistrationForm',

  mixins: [
    proxy({ type: 'object' }),
    validation
  ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      consentsValidation: false,
      showEmailDescriptionDialog: false
    }
  },

  computed: {
    usernameValidation() {
      if (this.proxy.username && !isValidUserName(this.proxy.username)) {
        return this.getTranslate(
          'errors.validation.types.invalid',
          {
            field: this.getTranslate(`${Services.registration}.labels.username`).toLowerCase()
          }
        )
      }
    },

    emailValidation() {
      if (this.proxy.data.email && !isValidEmail(this.proxy.data.email)) {
        return this.getTranslate(
          'errors.validation.types.email',
          {
            field: this.getTranslate(`${Services.registration}.labels.email`).toLowerCase()
          }
        )
      }
    },
    phoneValidation() {
      if (this.proxy.data.phone && !isValidPhone(this.proxy.data.phone)) {
        return this.getTranslate(
          'errors.validation.types.phoneNumber',
          {
            field: this.getTranslate(`${Services.registration}.labels.phone`).toLowerCase()
          }
        )
      }
    },

    validation() {
      return !!(
        isValidUserName(this.proxy.username) &&
        isValidPassword(this.proxy.password) &&
        !isEmpty(this.proxy.data.firstName) &&
        isValidEmail(this.proxy.data.email) &&
        isValidPhone(this.proxy.data.phone) &&
        this.consentsValidation
      )
    }
  },

  render
}
